import { useEffect } from 'react';
import { useRouter } from '../router';
var Redirect = function (_a) {
    var to = _a.to, _b = _a.condition, condition = _b === void 0 ? true : _b, _c = _a.options, options = _c === void 0 ? {} : _c;
    var router = useRouter();
    useEffect(function () {
        if (typeof window !== 'undefined' && condition) {
            router.push(to, options);
        }
    }, [condition]);
    return null;
};
export default Redirect;
//# sourceMappingURL=Redirect.js.map